import { useTeams } from "../lib/teams";
import DashboardPage from "./DashboardPage";
import ParentDashboard from "./ParentDashboard";

/**
 * Renders the appropriate dashboard based on the user's role on the active team.
 * - parent: child-focused dashboard
 * - others (owner/director): staff dashboard
 */
export default function DashboardRouter() {
  const { activeTeam } = useTeams();
  if (activeTeam?.my_role === "parent") {
    return <ParentDashboard />;
  }
  return <DashboardPage />;
}
